import { Component, OnInit,ViewChild } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ExcelService } from '../service/tableUtility.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-orderhistory',
  templateUrl: './orderhistory.component.html',
  styleUrls: ['./orderhistory.component.css']
})
export class OrderhistoryComponent implements OnInit {

  showFilter:boolean=false

  dataSource: any;
  tableData: [] = [];
  userDetails:any;
  userSessionData:any
  read:any;
  write:any;
  delete:any;
  export:any
  displayedColumns = ['accountEmailId','vendorId', 'orderId','createdDate','button']
  dataSourceProductDetails:any;
  displayedColumnsProductDetails=['productName','productImage','description','productStatus','updatingQuantity']
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  myurl: string;
  productImageId: any;
  showCustomisedSearch: boolean;
  searchValue: string;
  filterValueSelected: string;
  constructor(private cs:CucurachaAdminService,private excelService: ExcelService) { 
    this.myurl = this.cs.endpoint;

  } 
   filter(){
    this.getAllOrderHistory()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""



    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""




    }
  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForOrderHistory(this.filterValueSelected, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSource = new MatTableDataSource(data)

      })
    }
    else {
      this.getAllOrderHistory()
    }
  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getAllOrderHistory();

  }
  viewImages(id:any){
    this.productImageId=id
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  exportTable(){
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.tableData = (this.dataSource.filteredData)
    console.log(this.tableData)
    this.excelService.exportAsExcelFile(this.tableData, 'OrderHistory');
    this.cs.exportLogAdd(this.userDetails.emailId, 'OrderHistory').subscribe((data) => {
    })
  }
  getAllOrderHistory(){
    this.cs.getAllOrderHistoryManagement().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })

  }
  getAllProductDetailsByOrderId(id:any){
    this.cs.getAllProductDetailsByOrderIdInOrdersList(id).subscribe((data)=>{
      console.log(data[0].productdetails.productName)

      this.dataSourceProductDetails = new MatTableDataSource(data)
      this.dataSourceProductDetails.sort = this.sort
      this.dataSourceProductDetails.paginator = this.paginator
    })

  }
  ngOnInit(): void {
    this.getAllOrderHistory()
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails=data[0]
      this.read=(this.userDetails.roledetails[0].components[0].component_name[0][0].orderHistory_management.permissions[0].read);
      this.write=(this.userDetails.roledetails[0].components[0].component_name[0][0].orderHistory_management.permissions[0].write)
      this.delete=(this.userDetails.roledetails[0].components[0].component_name[0][0].orderHistory_management.permissions[0].delete)
      this.export=(this.userDetails.roledetails[0].components[0].component_name[0][0].orderHistory_management.permissions[0].export)

    })
  }

}
